<template>
    <div class="card">
        <h6>Search Criteria:</h6>
        <Accordion>
            <AccordionTab header="Use as few or as many as you wish, partial matches are acceptable.">
                <!-- All the criterias here -->
                <div class="p-fluid formgrid grid">
                    <!-- From Date: -->
                    <div class="field col-6 md:col-3">
                        <label for="dateFrom">Date From:</label>
                        <Calendar :showIcon="true" :showButtonBar="true" dateFormat="dd-mm-yy" v-model="criteria.date_from"></Calendar>
                    </div>
                    <!-- To Date: -->
                    <div class="field col-6 md:col-3">
                        <label for="dateTo">Date To:</label>
                        <Calendar :showIcon="true" :showButtonBar="true" dateFormat="dd-mm-yy" v-model="criteria.date_to"></Calendar>
                    </div>
                    <!-- Client -->
                    <div class="field col-6 md:col-3" v-if="!props.unassessedFlag">
                        <UsersPicker v-model="criteria.user_id" :label="'Client'" />
                    </div>

                    <!-- Assessment Code -->
                    <div class="field col-6 md:col-3">
                        <label for="assessment">Assessment:</label>
                        <Dropdown v-model="criteria.assessment_code" :options="assessments" filter optionLabel="name" optionValue="code" placeholder="Select an assessment" :showClear="true" />
                    </div>

                    <!-- Result Based -->
                    <div v-if="showResult" class="field col-6 md:col-3">
                        <BaseSelectionInput v-model="criteria.result" label="Assessment Result" :radio-type="true" :options="passFailOptions" />
                    </div>

                    <div class="mt-4 formgrid grid col-8">
                        <div class="field col-6 md:col-3">
                            <Button type="button" label="Search" icon="pi pi-search" :loading="loading" @click="searchCriteria" />
                        </div>
                        <div class="field col-6 md:col-3">
                            <Button type="button" label="Clear" icon="pi pi-trash" @click="clearCriteria" />
                        </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import UsersPicker from '@/components/user/UsersPicker';

import { ref, onMounted, defineProps } from 'vue';
import { storeToRefs } from 'pinia';

import { useAnswerStore } from '../store';
import { useAssessmentStore } from '../../assessment/store';

const props = defineProps({
    unassessedFlag: {
        type: Boolean,
        default: false,
    },
    showResult:{
        type: Boolean,
        default:false
    }
});

const answerStore = useAnswerStore();
const assessmentStore = useAssessmentStore();

// Store states
const { criteria } = storeToRefs(answerStore);
const { assessments } = storeToRefs(assessmentStore);

// Component states
const loading = ref(false);
const passFailOptions = ref([
    { id: 1, name: 'Pass', value: 'pass' },
    { id: 2, name: 'Fail', value: 'fail' },
]);

onMounted(async () => {
    await clearCriteria()
    await loadAssessments();
});

const loadAssessments = async () => {
    // load all the assessments for criteria dropdown
    await assessmentStore.fetchAllAssessments();
};

const searchCriteria = async () => {
    loading.value = true;
    setTimeout(async () => {
        loading.value = false;
        // if unassessedFlag is true then it means we are are using this criteria filter untested/unassessed users
        if (props.unassessedFlag) {
            await answerStore.getUnassessedUsers();
        }
        // otherwise for normal assessment filterings
        else {
            await answerStore.getAllAnswers(criteria.value);
        }
    }, 500);
};

const clearCriteria = async () => {
    answerStore.clearCriteria();
    if (props.unassessedFlag) {
        await answerStore.getUnassessedUsers();
    }
};
</script>
